__turbopack_context__.v({
  "amount1": "Heart-module-scss-module__n_hr6a__amount1",
  "amount2": "Heart-module-scss-module__n_hr6a__amount2",
  "desktopOnly": "Heart-module-scss-module__n_hr6a__desktopOnly",
  "heart": "Heart-module-scss-module__n_hr6a__heart",
  "mobileOnly": "Heart-module-scss-module__n_hr6a__mobileOnly",
  "ornament": "Heart-module-scss-module__n_hr6a__ornament",
});
